"use strict";
import { atom } from "jotai";
export var MenuState = /* @__PURE__ */ ((MenuState2) => {
  MenuState2["DEFAULT"] = "default";
  MenuState2["SETTINGS"] = "settings";
  MenuState2["LANGUAGE_SETTINGS"] = "language_settings";
  MenuState2["PORTFOLIO_BALANCE"] = "portfolio_balance_settings";
  MenuState2["LOCAL_CURRENCY_SETTINGS"] = "local_currency_settings";
  MenuState2["LIMITS"] = "limits";
  MenuState2["POOLS"] = "pools";
  MenuState2["PASSKEYS"] = "passkeys";
  MenuState2["OTHER_WALLETS"] = "other_wallets";
  return MenuState2;
})(MenuState || {});
export const miniPortfolioMenuStateAtom = atom("default" /* DEFAULT */);
export var ModalState = /* @__PURE__ */ ((ModalState2) => {
  ModalState2[ModalState2["DEFAULT"] = 0] = "DEFAULT";
  ModalState2[ModalState2["CEX_TRANSFER"] = 1] = "CEX_TRANSFER";
  ModalState2[ModalState2["QR_CODE"] = 2] = "QR_CODE";
  return ModalState2;
})(ModalState || {});
export const miniPortfolioModalStateAtom = atom(void 0);
